// GambaRates.js - Complete configuration for all mystery boxes
const GambaRates = {
    // Mystery Capsule: 10 items total (7 regular + 3 rare)
    shitCap: {
        name: "Dynamically Dyed Collectibles Capsule",
        image: "https://images.neopets.com/items/fa882d5c535524.gif",
        pools: {
            regular: [
                { name: "Court Dancers Collectors Villainous Eye Shadow and Contacts", image: "https://images.neopets.com/items/633c191aa2bccb.gif" },
                { name: "Court Dancers Collectors Mystic Eye Shadow and Contacts", image: "https://images.neopets.com/items/c663f83de5c966.gif" },
                { name: "Court Dancers Collectors Smokey Eye Shadow and Contacts", image: "https://images.neopets.com/items/efcb16c2653804.gif" },
                { name: "Viras Angelic Collectors Horns", image: "https://images.neopets.com/items/2a1760b89fad51.gif" },
                { name: "Viras Iridescent Collectors Horns", image: "https://images.neopets.com/items/6e54e0504c9b3b.gif" },
                { name: "Viras Dark Night Collectors Horns", image: "https://images.neopets.com/items/cc00bc382fc9f4.gif" },
                { name: "Kanriks Collectors Silver Cloak and Cape", image: "https://images.neopets.com/items/c0fd1a9e33dc6f.gif" },
                { name: "Kanriks Collectors Midnight Cloak and Cape", image: "https://images.neopets.com/items/9fdc2aecc19c4f.gif" },
                { name: "Kanriks Collectors Rust Cloak and Cape", image: "https://images.neopets.com/items/87b1511dec8120.gif" },
                { name: "Twilight in King Hagan Collectors Balcony Background", image: "https://images.neopets.com/items/395079c2583d5a.gif" },
                { name: "Nighttime in King Hagan Collectors Balcony Background", image: "https://images.neopets.com/items/19e5656529b938.gif" },
                { name: "Sunset in King Hagan Collectors Balcony Background", image: "https://images.neopets.com/items/5dfa49c201d347.gif" },
                { name: "Collectible In The Iridescent Brightvale Castle Background", image: "https://images.neopets.com/items/a108c3253cdbf0.gif" },
                { name: "Collectible In The Solemn Brightvale Castle Background", image: "https://images.neopets.com/items/6e16458aa89c42.gif" },
                { name: "Collectible In The Midnight Brightvale Castle Background", image: "https://images.neopets.com/items/4fcb700443c628.gif" },
                { name: "Halimas Spectral Crypt Collectors Background", image: "https://images.neopets.com/items/dc4fbb9b5b5fe2.gif" },
                { name: "Halimas Void Crypt Collectors Background", image: "https://images.neopets.com/items/c3a16bcac3fb30.gif" },
                { name: "Halimas Marble Crypt Collectors Background", image: "https://images.neopets.com/items/511a6628d41b2d.gif" },
                { name: "Daytime in Faerieland Library Collectors Background", image: "https://images.neopets.com/items/c0ca8ddb70465b.gif" },
                { name: "Midnight in Faerieland Library Collectors Background", image: "https://images.neopets.com/items/36a7f191415c24.gif" },
                { name: "Sunset in Faerieland Library Collectors Background", image: "https://images.neopets.com/items/5d35fdbf179623.gif" },
                { name: "Neon Cyberpunk Grundo Programmer Servers and Screens Collectible", image: "https://images.neopets.com/items/cb963ff23af51e.gif" },
                { name: "Hacker Grundo Programmer Servers and Screens Collectible", image: "https://images.neopets.com/items/d823d9ce925bfb.gif" },
                { name: "RGB Grundo Programmer Servers and Screens Collectible", image: "https://images.neopets.com/items/4202c39c568ee6.gif" },
                { name: "Archies Opalescent Collectible Shells Foreground", image: "https://images.neopets.com/items/a28b55ca3d85cd.gif" },
                { name: "Archies Pastel Rainbow Collectible Shells Foreground", image: "https://images.neopets.com/items/e4b4d15cb3a977.gif" },
                { name: "Archies White Collectible Shells Foreground", image: "https://images.neopets.com/items/f29e0eaeb00c7b.gif" },
                { name: "Green Royal Potionery Valentines Foreground Collectible", image: "https://images.neopets.com/items/614e6042ebe923.gif" },
                { name: "Purple Royal Potionery Valentines Foreground Collectible", image: "https://images.neopets.com/items/1e829d0a05a934.gif" },
                { name: "Blue Royal Potionery Valentines Foreground Collectible", image: "https://images.neopets.com/items/a6a74d06c2ccc0.gif" }
            ]
        },
        outcomes: [
            { weight: 0.12, items: [{ fromPool: "regular", count: 2 }] },
            { weight: 0.88, items: [{ fromPool: "regular", count: 1 }] },
        ],
    },
    // Mystery Capsule: 10 items total (7 regular + 3 rare)
    mysteryCapsule: {
        name: "Regular Mystery Capsule (10 items)",
        image: "https://images.neopets.com/items/745mjij23h.gif",
        pools: {
            regular: [
                { name: "Regular Item #1", image: "https://images.neopets.com/items/ggmf2a2c87.gif" },
                { name: "Regular Item #2", image: "https://images.neopets.com/items/aigl4b7jii.gif" },
                { name: "Regular Item #3", image: "https://images.neopets.com/items/bh7h7djbj6.gif" },
                { name: "Regular Item #4", image: "https://images.neopets.com/items/cn5femd95j.gif" },
                { name: "Regular Item #5", image: "https://images.neopets.com/items/0m650f99jl.gif" },
                { name: "Regular Item #6", image: "https://images.neopets.com/items/63d5f6g0e8.gif" },
                { name: "Regular Item #7", image: "https://images.neopets.com/items/1jllni9hji.gif" },
            ],
        },
        outcomes: [
            { weight: 0.09, items: [{ fromPool: "regular", count: 1 }, { specific: "LE Item #1", image: "https://images.neopets.com/items/e564b3hf99.gif" }] },
            { weight: 0.09, items: [{ fromPool: "regular", count: 1 }, { specific: "LE Item #2", image: "https://images.neopets.com/items/ci0hei0ja1.gif" }] },
            { weight: 0.09, items: [{ fromPool: "regular", count: 1 }, { specific: "LE Item #3", image: "https://images.neopets.com/items/0ld6jmef62.gif" }] },
            { weight: 0.73, items: [{ fromPool: "regular", count: 1 }] },
        ],
    },

    // Pet Day: 6 items total (5 regular + 1 rare)
    petDay: {
        name: "Pet Day Mystery Capsule",
        image: "https://images.neopets.com/items/gc7n79jdck.gif",
        pools: {
            regular: [
                { name: "Regular Item #1", image: "https://images.neopets.com/items/anh6al7a10.gif" },
                { name: "Regular Item #2", image: "https://images.neopets.com/items/9d2101kbl3.gif" },
                { name: "Regular Item #3", image: "https://images.neopets.com/items/3e8d046367.gif" },
                { name: "Regular Item #4", image: "https://images.neopets.com/items/ca4ng444am.gif" },
                { name: "Regular Item #5", image: "https://images.neopets.com/items/5nhnjf9b9e.gif" },
            ],
        },
        outcomes: [
            { weight: 0.10, items: [{ specific: "LE Item", quantity: 1, image: "https://images.neopets.com/items/bd5gck3a28.gif" }] },
            { weight: 0.90, items: [{ fromPool: "regular", count: 1 }] },
        ],
    },

    // Mini Mystery Capsule #1: 6 items, equal chance
    mini1: {
        name: "Mini Mystery Capsule #1 (6 Items)",
        image: "https://images.neopets.com/items/glgc9j0jmk.gif",
        pools: {
            items: [
                { name: "Item #1", image: "https://images.neopets.com/items/7ak2jbbdjb.gif" },
                { name: "Item #2", image: "https://images.neopets.com/items/694mcfkg0l.gif" },
                { name: "Item #3", image: "https://images.neopets.com/items/650h1hne42.gif" },
                { name: "Item #4", image: "https://images.neopets.com/items/6i5f57h0cf.gif" },
                { name: "Item #5", image: "https://images.neopets.com/items/hc89i845kd.gif" },
                { name: "Item #6", image: "https://images.neopets.com/items/2b2k568dc7.gif" },
            ],
        },
        outcomes: [{ weight: 1.0, items: [{ fromPool: "items", count: 1 }] }],
    },

    // Mini Mystery Capsule #2: 5 items, equal chance
    mini2: {
        name: "Mini Mystery Capsule #2 (5 Items)",
        image: "https://images.neopets.com/items/mall_mc_babycolours.gif",
        pools: {
            items: [
                { name: "Item #1", image: "https://images.neopets.com/items/mall_acc_pinkbaby.gif" },
                { name: "Item #2", image: "https://images.neopets.com/items/mall_acc_yellowbaby1.gif" },
                { name: "Item #3", image: "https://images.neopets.com/items/mall_acc_greenbaby1.gif" },
                { name: "Item #4", image: "https://images.neopets.com/items/mall_acc_bluebaby.gif" },
                { name: "Item #5", image: "https://images.neopets.com/items/mall_acc_purplebaby.gif" },
            ],
        },
        outcomes: [{ weight: 1.0, items: [{ fromPool: "items", count: 1 }] }],
    },

    // Closet Essentials: abstracted to 2 outcomes
    closetEssentials: {
        name: "Closet Essentials Mystery Capsule",
        image: "https://images.neopets.com/items/7d3b3353ba.gif",
        pools: {},
        outcomes: [
            { weight: 0.10, items: [{ specific: "2 Item Capsule", quantity: 1, image: "https://images.neopets.com/ncmall/2009/mystery_cap_adv/cap_question.png" }] },
            { weight: 0.90, items: [{ specific: "1 Item Capsule", quantity: 1, image: "https://images.neopets.com/ncmall/2009/mystery_cap_adv/cap_question.png" }] },
        ],
    },

    // Retired (no bonus)
    retiredNoBonus: {
        name: "Retired Mystery Capsule (No Bonus)",
        image: "https://images.neopets.com/items/mall_rmc_fallharvest.gif",
        pools: {},
        outcomes: [
            { weight: 0.12, items: [{ specific: "2 Item Capsule", quantity: 1, image: "https://images.neopets.com/ncmall/2009/mystery_cap_adv/cap_question.png" }] },
            { weight: 0.88, items: [{ specific: "1 Item Capsule", quantity: 1, image: "https://images.neopets.com/ncmall/2009/mystery_cap_adv/cap_question.png" }] },
        ],
    },

    // Retired (with bonus): 4 items total
    retiredWithBonus: {
        name: "Retired Mystery Capsule (With Bonus)",
        image: "https://images.neopets.com/items/68nj3gi740.gif",
        pools: {},
        outcomes: [
            { weight: 0.08, items: [{ name: "Regular Retired Item", quantity: 2, image: "https://images.neopets.com/winter/shopofmystery_item.gif" }, { specific: "LE Item #1", image: "https://images.neopets.com/items/e1c9a7d530.gif" }] },
            { weight: 0.08, items: [{ name: "Regular Retired Item", quantity: 2, image: "https://images.neopets.com/winter/shopofmystery_item.gif" }, { specific: "LE Item #2", image: "https://images.neopets.com/items/b6d2f1a907.gif" }] },
            { weight: 0.08, items: [{ name: "Regular Retired Item", quantity: 2, image: "https://images.neopets.com/winter/shopofmystery_item.gif" }, { specific: "LE Item #3", image: "https://images.neopets.com/items/7f0a3c9d85.gif" }] },
            { weight: 0.76, items: [{ name: "Regular Retired Item", quantity: 1, image: "https://images.neopets.com/winter/shopofmystery_item.gif" }] },
        ],
    },

    // Birthday capsule: similar to retiredWithBonus but different rates
    birthday: {
        name: "Birthday Mystery Capsule",
        image: "https://images.neopets.com/items/243bk2kld2.gif",
        pools: {
            regular: [
                { name: "Regular Retired Item", image: "https://images.neopets.com/winter/shopofmystery_item.gif" },
            ],
        },
        outcomes: [
            { weight: 0.10, items: [{ fromPool: "regular", count: 2 }, { specific: "Bonus Item #1", image: "https://images.neopets.com/items/5f5eganh4i.gif" }] },
            { weight: 0.10, items: [{ fromPool: "regular", count: 2 }, { specific: "Bonus Item #2", image: "https://images.neopets.com/items/51jn4b6a53.gif" }] },
            { weight: 0.10, items: [{ fromPool: "regular", count: 2 }, { specific: "Bonus Item #3", image: "https://images.neopets.com/items/4l1901b527.gif" }] },
            { weight: 0.70, items: [{ fromPool: "regular", count: 1 }] },
        ],
    },

    // New Years: 6 items total (buyable + 5 rares)
    newYears: {
        name: "New Years Mystery Capsule",
        image: "https://images.neopets.com/items/mall_mc_newyear2023.gif",
        pools: {
            regular: [
                { name: "Buyable Item", image: "https://images.neopets.com/winter/shopofmystery_item.gif" },
            ],
        },
        outcomes: [
            { weight: 0.06, items: [{ fromPool: "regular", count: 1, buyable: true }, { specific: "LE Item #1", image: "https://images.neopets.com/items/mall_bg_newyears_moneytree.gif" }] },
            { weight: 0.06, items: [{ fromPool: "regular", count: 1, buyable: true }, { specific: "LE Item #2", image: "https://images.neopets.com/items/mall_bg_newyears_warfwharf.gif" }] },
            { weight: 0.06, items: [{ fromPool: "regular", count: 1, buyable: true }, { specific: "LE Item #3", image: "https://images.neopets.com/items/mall_bg_newyears_ednastower.gif" }] },
            { weight: 0.06, items: [{ fromPool: "regular", count: 1, buyable: true }, { specific: "LE Item #4", image: "https://images.neopets.com/items/mall_bg_newyears_symolhole.gif" }] },
            { weight: 0.06, items: [{ fromPool: "regular", count: 1, buyable: true }, { specific: "LE Item #5", image: "https://images.neopets.com/items/mall_bg_newyears_wishingwell.gif" }] },
            { weight: 0.70, items: [{ fromPool: "regular", count: 1, buyable: true }] },
        ],
    },

    // Gift Box: 3 items with different quantities
    giftBox: {
        name: "Gift Box Mystery Capsule",
        image: "https://images.neopets.com/items/mall_gbmc_smorgasbord.gif",
        pools: {
            regular: [
                { name: "Buyable Item", image: "https://images.neopets.com/winter/shopofmystery_item.gif" },
            ],
            box: [
                { name: "Basic Gift Box", image: "https://images.neopets.com/items/mall_giftbox_basic.gif" },
            ],
        },
        outcomes: [
            { weight: 0.10, items: [{ fromPool: "regular", count: 2, buyable: true }, { fromPool: "box", count: 4, box: true }, { specific: "LE Box", quantity: 1, image: "https://images.neopets.com/items/mall_gb_timeforlunch.gif" }] },
            { weight: 0.15, items: [{ fromPool: "regular", count: 1, buyable: true }, { fromPool: "box", count: 3, box: true }] },
            { weight: 0.75, items: [{ fromPool: "regular", count: 1, buyable: true }, { fromPool: "box", count: 2, box: true }] },
        ],
    },

    // Black Friday Gift Box
    blackFriday: {
        name: "Black Friday Gift Box Mystery Capsule",
        image: "https://images.neopets.com/items/bj8em0e2g6.gif",
        pools: {
            regular: [
                { name: "Buyable Item", image: "https://images.neopets.com/winter/shopofmystery_item.gif" },
            ],
        },
        outcomes: [
            { weight: 0.06, items: [{ fromPool: "regular", count: 2, buyable: true }, { specific: "Basic Gift Box", quantity: 6, image: "https://images.neopets.com/items/mall_giftbox_basic.gif" }, { specific: "LE Box", quantity: 1, image: "https://images.neopets.com/items/flj2hi4f94.gif" }] },
            { weight: 0.10, items: [{ fromPool: "regular", count: 1, buyable: true }, { specific: "Basic Gift Box", quantity: 5, image: "https://images.neopets.com/items/mall_giftbox_basic.gif" }] },
            { weight: 0.84, items: [{ fromPool: "regular", count: 1, buyable: true }, { specific: "Basic Gift Box", quantity: 4, image: "https://images.neopets.com/items/mall_giftbox_basic.gif" }] },
        ],
    },

    // Gram: 2 items
    gram: {
        name: "Gram",
        image: "https://images.neopets.com/items/mall_gram_natfan1.gif",
        pools: {},
        outcomes: [
            { weight: 0.20, items: [{ specific: "Gram with Bonus", quantity: 1, image: "https://images.neopets.com/items/mall_trink_allstar.gif" }] },
            { weight: 0.80, items: [{ specific: "Gram with No Bonus", quantity: 1, image: "https://images.neopets.com/items/mall_gram_natfan1.gif" }] },
        ],
    },

    // Candles: Tier 1 & 2 with exclusive pool
    candles: {
        name: "Wish Candles",
        image: "https://images.neopets.com/items/mall_wishcandle_fairgrounds1.gif",
        pools: {
            regular: [
                { name: "Reg Item #1", image: "https://images.neopets.com/items/mall_trink_carnivalballoonarch.gif" },
                { name: "Reg Item #2", image: "https://images.neopets.com/items/mall_hh_candypopcorn.gif" },
                { name: "Reg Item #3", image: "https://images.neopets.com/items/mall_trink_cottoncandy.gif" },
                { name: "Reg Item #4", image: "https://images.neopets.com/items/mall_clo_carnivaldress.gif" },
                { name: "Reg Item #5", image: "https://images.neopets.com/items/mall_fg_carnivaltreats.gif" },
            ],
        },
        outcomes: [
            { weight: 0.12, items: [{ fromPool: "regular", count: 1 }, { specific: "Bonus Item", image: "https://images.neopets.com/items/mall_bg_fairground.gif" }] },
            { weight: 0.88, items: [{ fromPool: "regular", count: 1 }] },
        ],
    },
};

export default GambaRates;